import * as React from "react";
import { Component } from "../Utils";
import { MENTORS_URL } from "../../router/urls";

interface ActionsProps {
	schema: any;
	mode: string;
	progress: number;
	form_type: string;
	process_id: number;
	isVisible: boolean;
	status: number;
	isPdf: boolean;
	onSend: () => void;
	onConfirmProcess: (accept: boolean) => void;
	onPDF: () => void;
	onDraft: () => void;
	onDocument: () => void;
	onRevoke: () => void;
	onDelete: () => void;
	onReturn?: () => void;
	onCopy: () => void;
	onAddition: () => void;
	readonly?: boolean;
	user: any;
	allowDefence?: boolean;
}

class Actions extends Component<ActionsProps, null> {
	render() {
		const { status, schema, mode, readonly, user, allowDefence } = this.props;

		return (
			<div className="reportbox-actions">
				<div className="note">
					{mode === "suspended" && <span style={{ color: "red" }}>Приём заявок временно приостановлен</span>}
					{mode === "working" && !readonly && <span>Данные заявки сохраняются автоматически</span>}
				</div>
				<div className="btn-content">
					{window.location.pathname.indexOf(MENTORS_URL) > -1 && user.is_master_mentor && <div />}
					{window.location.pathname.indexOf(MENTORS_URL) > -1 && user.is_mentor && (
						<>
							<button
								className="btn btn-success btn-sm pull-right"
								onClick={() => {
									this.props.onReturn();
								}}
							>
								Назад к списку заявок
							</button>
							{!schema.mentor_confirmed && (
								<>
									<button
										className="btn btn-success btn-sm pull-right"
										onClick={() => this.props.onConfirmProcess(true)}
									>
										В работу
									</button>
									<button
										className="btn btn-danger btn-sm pull-right"
										onClick={() => this.props.onConfirmProcess(false)}
									>
										Отказаться
									</button>
								</>
							)}
						</>
					)}
					{user.isAuth && window.location.pathname.indexOf(MENTORS_URL) < 0 && (
						<>
							<button
								className="btn btn-success btn-sm pull-right"
								onClick={() =>
									this.props.onReturn()
								}
							>
								Назад к списку заявок
							</button>
							{mode === "working" &&
								((status === 0 && !readonly) || (status === 12) || (status === 21) || (status === 22)) &&
								!user.is_master_mentor &&
								!user.is_mentor && (
									<button className="btn btn-success btn-sm pull-right" onClick={this.props.onDocument}>
										Отправить
									</button>
								)}
						</>
					)}
				</div>
			</div>
		);
	}
}

export default Actions;
